import React, { useContext } from "react";
import { Context } from "../../context/Context";
import axios from "axios";
import "./order.css";
import Swal from "sweetalert2";
import { Button } from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
const Order = () => {
  const history = useHistory();
  const { reservation } = useContext(Context);
  const handleSubmitData = async () => {
    if (!window.sessionStorage.getItem("isSended")) {
      try {
        await axios.post(
          "https://www.rezerwacjaparkingu.com/backend_artlot/api/reservations",
          reservation
        );
      } catch (err) {
        console.log(err);
      }
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Dziękujemy za złożenie rezerwacji",
        footer: "Potwierdzenie rezerwacji zostało wysłane mailowo",
        confirmButtonText: "Powrót",
        confirmButtonColor: "#1267a2",
      }).then((result) => {
        if (result.isConfirmed) {
          history.push("/");
        }
      });
      window.sessionStorage.setItem("isSended", true);
    } else {
      Swal.fire({
        icon: "error",
        title: "Błąd",
        text: "Dane zostały już zarezerwowane",
        footer: "Potwierdzenie rezerwacji zostało wysłane mailowo!",
        confirmButtonText: "Powrót",
        confirmButtonColor: "#1267a2",
      }).then((result) => {
        if (result.isConfirmed) {
          history.push("/");
        }
      });
    }
  };
  return (
    <>
      <div className="reservationWrapper">
        <div className="img">
          <img
            src="https://www.rezerwacjaparkingu.com/parking-pyrzowice-art-lot/assets/menulogo.png"
            alt="logoMegaParking"
            style={{ marginTop: "40px" }}
          />
          <span>Potwierdzenie rezerwacji</span>
        </div>
        <div className="details">
          <div className="left">
            <div className="headline">Dane Personalne</div>
            <p>Imię</p>
            <span>{reservation.username}</span>
            <p>Nazwisko</p>
            <span>{reservation.surname}</span>
            <p>Adres email</p>
            <span>{reservation.email}</span>
            <p>Telefon</p>
            <span>{reservation.number}</span>
            <p>Cel podróży</p>
            <span>
              {reservation.destination ? reservation.destination : "nie podano"}
            </span>
          </div>
          <div className="right">
            <div className="headline">Dane rezerwacji</div>
            <p>Data przyjazdu</p>
            <span>{reservation.arriveData}</span>
            <p>Godzina przyjazdu</p>
            <span>{reservation.arriveHour}</span>
            <p>Data powrotu</p>
            <span>{reservation.leaveData}</span>
            <p>Godzina powrotu</p>
            <span>{reservation.leaveHour}</span>
            <p>Numer rejestracji samochodu</p>
            <span>{reservation.carId}</span>
            <p>Całkowita cena postoju</p>
            <span>{reservation.price}zł</span>
          </div>
        </div>
        <div className="confirm">
          <Button
            variant="contained"
            className="button"
            color="primary"
            size="small"
            onClick={handleSubmitData}
          >
            Rezerwuj
          </Button>
          <Link to="/" className="link">
            Anuluj
          </Link>
        </div>
      </div>
    </>
  );
};

export default Order;
